import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import axios from 'axios';
import cookie from "js-cookie"

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
export default function Checkout() {
  const navigate = useNavigate()
  // ...............................
  const [data, setData] = useState("")
  const [singleData, setsingleData] = useState("")
  // ...................................
const iddd=useParams().id
console.log(iddd,"iddd")
const getCookieUser = cookie.get("user");
      const userInfo = getCookieUser ? JSON.parse(getCookieUser) : null;
  const getData=async()=>{
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}/getSingleCar/${iddd}`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
          },
        }
      );
      console.log(result, "result")
      setsingleData(result.data.body)
  } catch (error) {
      console.log(error)
  }
  }
   useEffect(() => {
    getData()
      }, [])
  const OnchangeData = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    })
  }

  const dataaaInsert={
    name:data.name,
    carBookingId:iddd,
    email:data.email,
    country:data.country,
    state:data.state,
    phoneNumber:data.phoneNumber,
    city:data.city,
    address:data.address,
    zipCode:data.zipCode,
  }
  // ..................................
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {


      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/bookingController`,
        dataaaInsert,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
          },
        }
      );
      console.log(res, "res")
      toast.success(res.data.message);
      setData(res.data.data)
      navigate("/");
    } catch (error) {
      console.log(error, "Error");
    }
  };
  // ..................................
  return (
    <>
      <div className='container mt-5 py-5s'>
        <h1 className='border text-center py-3'>Book Car Washing Service</h1>
        <div className='row mt-5'>
          <div className='col-lg-6'>
            <img src={singleData?.image || ""} alt="" className='w-100' />
          </div>
          <div className='col-lg-6 border px-4 py-4'>
            <h3>{singleData?.title || "Car Washing Service"}</h3>
            <h4>Washing Price: Rs. {singleData?.price || ""}</h4>
            <p>Fill in your details to book the car washing service</p>
            <form onSubmit={handleSubmit} onChange={OnchangeData}>
              <div className='row'>
                <div className='col-lg-6'>
                  <label htmlFor="">Full Name:</label>
                  <input type="text" className='form-control'
                    name="name"
                    placeholder="Enter your full name (e.g., Rajesh Kumar)"
                  />
                </div>
                <div className='col-lg-6'>
                  <label htmlFor="">Email:</label>
                  <input type="text" className='form-control'
                    name="email"
                    placeholder="Enter your email (e.g., rajesh.kumar@gmail.com)"
                  />
                </div>
                <div className='col-lg-6'>
                  <label htmlFor="">Country:</label>
                  <input type="text" className='form-control'
                    name="country"
                    placeholder="Enter country (e.g., India)"
                  />
                </div>
                <div className='col-lg-6'>
                  <label htmlFor="">State:</label>
                  <input type="text" className='form-control'
                    name="state"
                    placeholder="Enter state (e.g., Maharashtra, Delhi, Karnataka)"
                  />
                </div>
                <div className='col-lg-6'>
                  <label htmlFor="">Phone Number:</label>
                  <input type="number" className='form-control'
                    name="phoneNumber"
                    placeholder="Enter 10-digit mobile number (e.g., 9876543210)"
                  />
                </div>
                <div className='col-lg-6'>
                  <label htmlFor="">City:</label>
                  <input type="text" className='form-control'
                    name="city"
                    placeholder="Enter city (e.g., Mumbai, Delhi, Bangalore)"
                  />
                </div>
                {/* <div className='col-lg-6'>
                  <label htmlFor="">Payment : </label>
                  <select id="" className='form-control'
                    name="payment"
                  >
                    <option value="Card">Card</option>
                    <option value="Cash On Devilery">Cash On Devilery</option>
                    <option value="Visha">Visha</option>
                  </select>
                </div> */}
                <div className='col-lg-12'>
                  <label htmlFor="">Address:</label>
                  <textarea className='form-control'
                    name="address"
                    placeholder="Enter complete address with area, street, landmark"
                  ></textarea>
                </div>
                <div className='col-lg-6'>
                  <label htmlFor="">Pin Code:</label>
                  <input type="number" className='form-control'
                    name="zipCode"
                    placeholder="Enter 6-digit pin code (e.g., 400001)"
                  />
                </div>
                <div className='col-lg-6 py-3'>
                  <img src="/img/stripe.png" alt="" srcset="" className='w-100' />
                </div>
                <div className='col-lg-6 mt-3 mb-3'>
                  <button type="submit" class="btn btn-primary py-3 px-5 animated slideInDown">Book Washing Service<i class="fa fa-arrow-right ms-3"></i></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
